import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "../Dialog";
import swal from "sweetalert2";
import UsersTable from "../Tables/UsersTable";
import { getEmailUsers } from "../../services/users";
import { addEmailCampaignRecipients } from "../../services/emailcampaigns";
import { Button } from "../StyledElements";

export const RecipientUsersDialog = ({ emailCampaign, show, onClose, onAddRecipients }) => {
  const [users, setUsers] = useState([]);
  const [saveText, setSaveText] = useState("Add Recipients");
  const selectedUsers = useRef([]);
  const filteredUsers = useRef([]);

  useEffect(() => {
    console.log("!!! RECIPIENT USERS DIALOG");
    const fetchUsers = async () => {
      const results = await getEmailUsers()
      console.log("!!! EMAIL USERS: ", results);
      if (results.success) {
        const clients = results.clients;
        console.log("!!! CLIENTS: ", clients);
        const users = results.users.map((user) => {
          return {
            ...user,
            client: clients[user.client_id] ?? "Unknown Client",
          }
        });
        setUsers(users);
      }
    }

    fetchUsers();
  }, []);

  const saveRecipients = async () => {
    // Implement your save logic here, e.g., send data to backend or update state
    console.log("!!! SELECTED USERS: ", selectedUsers.current);
    setSaveText("Saving...");
    if (!selectedUsers.current || selectedUsers.current.length === 0) {
      swal.fire({
        title: "Error",
        text: "No users selected.",
        icon: "error",
      });
      setSaveText("Add Recipients");
      return;
    }
    console.log("!!! ADDING RECIPIENTS: ", selectedUsers.current.length, emailCampaign.public_id);
    const results = await addEmailCampaignRecipients(emailCampaign.public_id, selectedUsers.current);
    if (results.success) {
      onAddRecipients(results.recipients);
      onClose();
    } else {
      setSaveText("Add Recipients");
      swal.fire({
        title: "Error",
        text: results.message || "Failed to save recipients.",
        icon: "error",
      });
    }
  };

  return (
    <Dialog
      title="Add Recipients"
      subtitle={""}
      show={show}
      onClose={onClose}
      onOK={saveRecipients}
      okText={saveText}
      closeText="Close"
      style={{ width: "90%", maxWidth: "1200px", height: "80vh", zIndex: 2000000000 }}
    >
      <div style={{ position: "absolute", top: "20px", right: "20px", zIndex: 2000000001 }}>
        <Button onClick={() => {
          selectedUsers.current = [...filteredUsers.current];
          saveRecipients();
        }}
        >
          Add All Visible</Button>
      </div>
      <UsersTable users={users} hideTitle={true} hideButtons={true} mode="select-email" onSelect={(recipients) => {
        selectedUsers.current = [...recipients];
        console.log("!!! SELECTED RECIPIENT IDS: ", selectedUsers.current);
      }} onFilter={(recipients) => {
        console.log("!!! FILTERED RECIPIENTS: ", recipients);
        filteredUsers.current = [...recipients];

      }} />
    </Dialog>
  );
};

export default RecipientUsersDialog;

